import { Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { defaultLocale, LanguageCode } from './language.model';
import { LocaleService } from './locale.service';

export interface LanguageNameAndRegion {
  name: string;
  region: string;
}

@Injectable({
  providedIn: 'root'
})
export class TranslationsService {
  public languageCodeToFriendlyNameMap: { [key in LanguageCode]: LanguageNameAndRegion } = {
    en: {
      name: 'English',
      region: ''
    },
    es: {
      name: 'Español',
      region: ''
    },
    'es-sa': {
      name: 'Español',
      region: 'Sudamérica'
    },
    fr: {
      name: 'Français',
      region: ''
    },
    'fr-qc': {
      name: 'Français',
      region: 'Québec'
    }
  };
  public defaultLanguage: LanguageCode = defaultLocale;
  public currentSelectedLanguage: LanguageCode = this.defaultLanguage;
  constructor(private translocoService: TranslocoService, private localeService: LocaleService) {}

  public changeLanguage(lang: LanguageCode = LanguageCode.en) {
    this.localeService.setLocale(lang);
    this.currentSelectedLanguage = lang;
    this.translocoService.load(lang).subscribe(() => {
      this.translocoService.setActiveLang(lang);
    });
  }
}
